/**
 * Map region filter definitions. Each option maps a human region to the ISO
 * 3166 country codes it covers; the map page sends the codes to
 * GET /jobs/map?countries=... and the server filters sites, depots and work
 * pins by farm-site/depot country_code. Purely a client-side vocabulary —
 * extending it needs no API change.
 *
 * 'Europe' deliberately excludes the UK & Ireland: the business treats them
 * as separate territories (see the user-form region list).
 */

const EUROPE = [
  'AD', 'AL', 'AT', 'AX', 'BA', 'BE', 'BG', 'BV', 'BY', 'CH', 'CY', 'CZ',
  'DE', 'DK', 'EE', 'ES', 'FI', 'FO', 'FR', 'GI', 'GR', 'HR', 'HU', 'IS',
  'IT', 'LI', 'LT', 'LU', 'LV', 'MC', 'MD', 'ME', 'MK', 'MT', 'NL', 'NO',
  'PL', 'PT', 'RO', 'RS', 'RU', 'SE', 'SI', 'SJ', 'SK', 'SM', 'UA', 'VA',
  'XK'
];

const NORTH_AMERICA = [
  'AG', 'AI', 'AW', 'BB', 'BL', 'BM', 'BQ', 'BS', 'BZ', 'CA', 'CR', 'CU',
  'CW', 'DM', 'DO', 'GD', 'GL', 'GP', 'GT', 'HN', 'HT', 'JM', 'KN', 'KY',
  'LC', 'MF', 'MQ', 'MS', 'MX', 'NI', 'PA', 'PM', 'PR', 'SV', 'SX', 'TC',
  'TT', 'US', 'VC', 'VG', 'VI'
];

const SOUTH_AMERICA = [
  'AR', 'BO', 'BR', 'CL', 'CO', 'EC', 'FK', 'GF', 'GS', 'GY', 'PE', 'PY',
  'SR', 'UY', 'VE'
];

const OCEANIA = [
  'AS', 'AU', 'CC', 'CK', 'CX', 'FJ', 'FM', 'GU', 'HM', 'KI', 'MH', 'MP',
  'NC', 'NF', 'NR', 'NU', 'NZ', 'PF', 'PG', 'PN', 'PW', 'SB', 'TK', 'TO',
  'TV', 'UM', 'VU', 'WF', 'WS'
];

const ASIA = [
  'AE', 'AF', 'AM', 'AZ', 'BD', 'BH', 'BN', 'BT', 'CN', 'GE', 'HK', 'ID',
  'IL', 'IN', 'IO', 'IQ', 'IR', 'JO', 'JP', 'KG', 'KH', 'KP', 'KR', 'KW',
  'KZ', 'LA', 'LB', 'LK', 'MM', 'MN', 'MO', 'MV', 'MY', 'NP', 'OM', 'PH',
  'PK', 'PS', 'QA', 'SA', 'SG', 'SY', 'TH', 'TJ', 'TL', 'TM', 'TR', 'TW',
  'UZ', 'VN', 'YE'
];

const AFRICA = [
  'AO', 'BF', 'BI', 'BJ', 'BW', 'CD', 'CF', 'CG', 'CI', 'CM', 'CV', 'DJ',
  'DZ', 'EG', 'EH', 'ER', 'ET', 'GA', 'GH', 'GM', 'GN', 'GQ', 'GW', 'KE',
  'KM', 'LR', 'LS', 'LY', 'MA', 'MG', 'ML', 'MR', 'MU', 'MW', 'MZ', 'NA',
  'NE', 'NG', 'RE', 'RW', 'SC', 'SD', 'SH', 'SL', 'SN', 'SO', 'SS', 'ST',
  'SZ', 'TD', 'TF', 'TG', 'TN', 'TZ', 'UG', 'YT', 'ZA', 'ZM', 'ZW'
];

/* Antarctica has no administering country and belongs to none of the business
   regions. It gets its own bucket rather than a wrong guess, so that every
   country the picker can offer still resolves to a territory. */
const ANTARCTICA = ['AQ'];

const UK = ['GB', 'IM', 'JE', 'GG'];

export const MAP_REGION_OPTIONS = [
  { value: 'uk', label: 'United Kingdom', codes: UK },
  { value: 'ireland', label: 'Ireland', codes: ['IE'] },
  { value: 'uk_ireland', label: 'UK & Ireland', codes: [...UK, 'IE'] },
  { value: 'europe', label: 'Europe', codes: EUROPE },
  { value: 'usa', label: 'USA', codes: ['US'] },
  { value: 'canada', label: 'Canada', codes: ['CA'] },
  { value: 'north_america', label: 'North America', codes: NORTH_AMERICA },
  { value: 'south_america', label: 'South America', codes: SOUTH_AMERICA },
  { value: 'oceania', label: 'Oceania', codes: OCEANIA },
  { value: 'asia', label: 'Asia', codes: ASIA },
  { value: 'africa', label: 'Africa', codes: AFRICA },
  { value: 'antarctica', label: 'Antarctica', codes: ANTARCTICA }
];
